import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const PageTitle = styled.div`
  display: flex;
`;

export const PageInfo = styled.div`
  margin-top: ${pxToRem('20px')};
`;

export const CardContainer = styled.div`
  display: flex;
  gap: ${pxToRem('20px')};
`;
